"use client";

import { Fragment } from "react";

import { useUserLoggedIn } from "~/lib/organizations/hooks/use-user-logged-in";

export default function SyncAccessTokenCookie() {
  useUserLoggedIn();

  return <Fragment />;
}
